// extracted by mini-css-extract-plugin
module.exports = {"root":"_17fL1","bg":"aIUc8","shadow":"_2zYh","leftBottom":"_2rBrP","rightBottom":"_13rfp","centerBottom":"_3o7Ko"};